import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class BackendInterceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // if (request.url.startsWith('file')) {
        //     return next.handle(request);
        // }
        // if (request.url.startsWith('local')) {
        //     request = request.clone({ url: this.configService.getConfig().localUrl + request.url.replace('local', '') });
        // } else {
     // request = request.clone({ url: 'http://localhost:3333' + request.url });
        // }
        return next.handle(request);
    }
}
